  export class Lote {
    constructor(
      public idempresa: string,
      public idprecompra: string,
      public numerolote: string,
      public descripcionlote: string,
      public lcompradas: number,
      public fecha?: Date,
      public procesado?: boolean,
      public disponible?: number,
      public status?: boolean,
      public _id?: string
     ) { }
  }


 
 
  

